'use client';

import Container from '@mui/material/Container';
import {useTranslation} from 'react-i18next';
import {LegalContent} from '../components/legal';
import {Section, Typography} from '../components/primitives';

export interface PrivacyPolicyPageProps {
  html: string;
}

// The page owns the single h1 so it stays translated and present for every
// tenant; the document body starts at h2. Between the site header and footer
// there is nothing else — no masthead, no banner.
export function PrivacyPolicyPage({html}: PrivacyPolicyPageProps) {
  const {t} = useTranslation();

  return (
    <Section>
      <Container>
        <Typography size="title-2" weight="bold" mobileSize="title-4" mobileWeight="bold" as="h1" sx={{textTransform: 'capitalize', mb: 3}}>
          {t('privacy_policy')}
        </Typography>
        <LegalContent html={html} />
      </Container>
    </Section>
  );
}

PrivacyPolicyPage.displayName = 'PrivacyPolicyPage';
